import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ArrowLeft } from "lucide-react";
import UsersTab from "../components/superadmin/UsersTab";
import WebsitesTab from "../components/superadmin/WebsitesTab";
import RolesTab from "../components/superadmin/RolesTab";

const VALID_TABS = ["users", "website", "roles"];

const TAB_TITLES = {
  users: "User Management",
  website: "Website Management",
  roles: "Role Management",
};

const SuperadminPanel = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const tabFromUrl = searchParams.get("tab");
  const activeTab = VALID_TABS.includes(tabFromUrl) ? tabFromUrl : "users";

  const handleTabChange = (value) => {
    setSearchParams({ tab: value }, { replace: true });
  };

  return (
    <div
      className="min-h-screen bg-gradient-to-br from-[#0f0f10] via-[#1a1a1b] to-[#0f0f10]"
      data-testid="superadmin-panel"
    >
      <header className="bg-[#1a1a1b]/80 backdrop-blur-xl border-b border-red-900/30 sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center gap-4">
            <Button
              onClick={() => navigate("/dashboard")}
              variant="ghost"
              size="sm"
              className="text-gray-300 hover:text-white hover:bg-red-900/20"
              data-testid="back-button"
            >
              <ArrowLeft className="mr-2" size={18} />
              Kembali
            </Button>
            <h1 className="text-2xl font-bold text-red-50">{TAB_TITLES[activeTab]}</h1>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Tabs value={activeTab} onValueChange={handleTabChange} className="space-y-6">
          {/* TabsList hidden — navigation handled by sidebar submenu */}
          <TabsList className="hidden">
            <TabsTrigger value="users" data-testid="tab-users">Users</TabsTrigger>
            <TabsTrigger value="website" data-testid="tab-website">Website</TabsTrigger>
            <TabsTrigger value="roles" data-testid="tab-roles">Roles</TabsTrigger>
          </TabsList>

          <TabsContent value="users">
            <UsersTab />
          </TabsContent>
          <TabsContent value="website">
            <WebsitesTab />
          </TabsContent>
          <TabsContent value="roles">
            <RolesTab />
          </TabsContent>
        </Tabs>
      </main>
    </div>
  );
};

export default SuperadminPanel;
